
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/loaderOnStage/styles.scss.css.virtualfile';
        module.exports = {"panel":"_panel_ubc2l_7"};